<script>
import ValidationRules from "@/helpers/validation-rules";
import {mapState} from "vuex";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    filter: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      model: { ...this.filter },
      dictionaries: {},
      formIsValid: true,
      vr: ValidationRules,
      key: 0,
    };
  },
  async mounted() {
    this.dictionaries = await this.$api.dictionaries.getTransactionDictionaries();
  },
  computed: {
    ...mapState({
      availableCurrencies: state => state.settings.availableCurrencies,
    }),
    visible: {
      get: function() {
        return this.show;
      },
      set: function(val) {
        this.$emit('update:show', val);
      },
    },
  },
  methods: {
    apply() {
      if(!this.$refs.form.validate()){
        return;
      }

      this.$emit('ok', this.model);
      this.visible = false;
    },
    processCustomer(data) {
      this.$set(this.model, 'terminalID', data.terminalID);
      this.model.consumerID = data.consumerID;
    },
    resetFilter(){
      this.model = {
        dateFrom: null,
        dateTo: null,
      };
      this.selectedCustomer = null;
    },
    resetValidation() {
      if (!this.$refs.form.validate()) {
        this.key++
      };
    },
  },
}
</script>
